import Error from "@components/ui/error";
import { useLingui } from "@lingui/react/macro";

export default function GenericError() {
  const { t } = useLingui();

  return (
    <Error
      heading={t`Hoppsan! Någonting gick snett`}
      description={t`Försök igen om en liten stund`}
      data-testid="error-search-message"
    />
  );
}
